import React from 'react'

import { useIntl } from 'react-intl'

import { formSelectMessages } from '@messages'

/**
 * Hook for create a custom promptTextCreator function for creatable select
 * @returns promptTextCreator function
 */
export function usePromptTextCreator(createText?: string) {
  const { formatMessage } = useIntl()
  return React.useCallback(
    (value: string) => `${createText ?? formatMessage(formSelectMessages.selectOnCreate)}: "${value}"`,
    [createText, formatMessage]
  )
}
